export default {
    state:{
        isCollapse:false
    },
    mutations: {
        isCollapse(state,v){
            return state.isCollapse=v
        }
    }
}


// WEBPACK FOOTER //
// ./src/jh/store/init.js